<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-3">
        <v-layout wrap>
            <v-flex xs12>
                <v-card
                    class="pl-1 pt-2"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <img
                            v-if="property"
                            :src="property.propertyPhotoUrl"
                            height="356"
                            width="500"
                            class="ml-2 pt-1"
                        />
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="property && property.id"
                            >
                                <div
                                    class="mt-2 display-1 font-weight-bold mb-0 ml-0"
                                >
                                    {{
                                        property.street +
                                            ", " +
                                            property.city +
                                            ", " +
                                            property.state +
                                            " " +
                                            property.zip
                                    }}
                                </div>
                                <div class="ml-3 mt-4">
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Purchase Price:
                                        </div>
                                        <div>
                                            {{
                                                property.purchasePrice
                                                    | currency
                                            }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            List Price:
                                        </div>
                                        <div>
                                            {{ property.listPrice | currency }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        style="width: 1000px;"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Property Link:
                                        </div>
                                        <a
                                            :href="property.propertyLink"
                                            target="_blank"
                                            class="website-link-text"
                                            >{{ property.propertyLink }}</a
                                        >
                                    </v-layout>

                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Sqft:
                                        </div>
                                        <div>
                                            {{ property.sqft }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Beds:
                                        </div>
                                        <div>
                                            {{ property.beds }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Bathrooms:
                                        </div>
                                        <div>
                                            {{ property.bathrooms }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Date:
                                        </div>
                                        <div>
                                            {{ property.date | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Construction Budget:
                                        </div>
                                        <div>
                                            {{
                                                property.constructionBudget
                                                    | currency
                                            }}
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>

                    <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openEditDialog"
                        >
                            Edit
                        </v-btn>
                    </v-layout> -->
                </v-card>

                <v-card
                    v-if="property"
                    class="pa-3 mt-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#transactions">
                            Transactions ({{ getTotalTransactionCount() }})
                            <v-icon>mdi-currency-usd</v-icon>
                        </v-tab>

                        <v-tab href="#documents">
                            Documents ({{ getDocumentsCount() }})
                            <v-icon>mdi-file-multiple</v-icon>
                        </v-tab>
                        <v-tab-item value="transactions">
                            <transaction-details
                                v-if="property && property.id"
                                :propertyID="property.id"
                                :property="property"
                                ref="transactionDetails"
                            ></transaction-details>
                        </v-tab-item>
                        <v-tab-item value="documents">
                            <property-documents
                                v-if="property && property.id"
                                :propertyID="property.id"
                                :property="property"
                                :reload="loadDocuments"
                                :documents="documents"
                                ref="propertyDocuments"
                            ></property-documents>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../utils/helpers.js";
import moment from "moment";
import transactionDetails from "./TransactionDetails.vue";
import propertyDocuments from "./PropertyDocuments.vue";

export default {
    components: {
        transactionDetails,
        propertyDocuments,
    },
    data: () => ({
        property: null,
        processing: false,
        loadingProprty: false,
        documents: [],

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadProprty();
            await this.loadDocuments();
        },
        async loadDocuments() {
            this.documents = await this.$http.get(
                "api/properties/getDocuments?propertyID=" +
                    this.$route.params.id
            );
        },
        async loadProprty() {
            const property = await this.$http.get(
                "api/Properties/GetProperty?id=" +
                    this.$route.params.id +
                    "&user=" +
                    this.$store.state.user
            );

            this.property = property;
            this.loadingProprty = false;
        },
        getTotalTransactionCount() {
            if (!this.$refs.transactionDetails) return 0;

            return this.$refs.transactionDetails.getTotalCount();
        },
        getDocumentsCount() {
            return this.documents.length;
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
</style>
